module.exports = __webpack_public_path__ + "img/t2-blue.f3ec9fc5.png";